import { useEffect } from 'react'
import { Switch, Route, useHistory, useParams } from 'react-router-dom'
import config from '@/config'
import useGetSuiteInfo from '@/hooks/get-suite-info'
import { ContractCreate, ContractPreview, ContractView } from '@/pages/Contract'
import { getTab } from '@/utils/get-tab'
import ListingApplications from '../ListingApplications'
import ListingChat from '../ListingChat'
import ListingDashboardHome from '../../../features/Listing/listing-dashboard'
import ListingNotes from '../ListingNotes'
import ListingShowings from '../ListingShowings'
import ListingSuggestedTenants from '../ListingSuggestedTenants'
import MarkRented from '../MarkRented'
import Sponsored from '../ListingSponsored'
import ListingInsights from '../ListingInsights'

const { WEB_URL } = config

const ListingDashboard = () => {
  const { listingId } = useParams()
  const history = useHistory()
  const listing = useGetSuiteInfo(listingId, {
    retry: 0,
    onError: err => {
      if (err.message === 'access denied') {
        window.location = `${WEB_URL}/rental-listings/${listingId}`
      }
    }
  })

  const current = history?.location?.pathname || ''
  useEffect(() => {
    const tab = getTab(listing)
    if (tab && tab === 'tenant') {
      const isContract = value => /^\/listing\/[^/]+\/contract/.exec(value)
      if (isContract(current)) return
      const url = current.replace(/^\/listing/g, '/tenant')
      if (current && url !== current) history.replace(url)
    }
  }, [listing, history, current])

  return (
    <>
      <Switch>
        <Route exact path="/listing/:listingId" component={ListingDashboardHome} />
        <Route
          exact
          path="/listing/:listingId/chat/:timelineId?"
          render={props => <ListingChat listing={listing} {...props} />}
        />
        <Route
          exact
          path="/listing/:listingId/suggested-tenants"
          component={ListingSuggestedTenants}
        />
        <Route exact path="/listing/:listingId/notes" component={ListingNotes} />
        <Route
          exact
          path="/listing/:listingId/sponsored"
          render={() => <Sponsored listing={listing} />}
        />
        <Route exact path="/listing/:listingId/insights" component={ListingInsights} />
        <Route exact path="/listing/:listingId/showings" component={ListingShowings} />
        <Route exact path="/listing/:listingId/applications" component={ListingApplications} />
        <Route
          exact
          path="/listing/:listingId/contract/:contractId/preview/:currentStep(terms)?"
          render={props => <ContractPreview noTitle {...props} />}
        />
        <Route
          path="/listing/:listingId/contract/create/:contractId(\d+)?"
          render={props => <ContractCreate noTitle {...props} />}
        />
        <Route
          exact
          path="/listing/:listingId/contract/:contractId/:step(review|terms|sign)?"
          render={props => <ContractView noTitle {...props} />}
        />
        <Route exact path="/listing/:listingId/mark-rented" component={MarkRented} />
      </Switch>
    </>
  )
}

export default ListingDashboard
